export default __webpack_public_path__ + "static/media/TargetingIcon_Light.b6c7746b.svg";